export const enterFullscreen = () => {
  const elem = document.documentElement; // o un altro elemento specifico
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) { /* Safari */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE11 */
    elem.msRequestFullscreen();
  }
}

export const exitFullscreen = () => {
  const elem = document;
  try{
    if (document.hasFocus()) {
      if (elem.exitFullscreen) {
        elem.exitFullscreen();
      } else if (elem.webkitExitFullscreen) {
        elem.webkitExitFullscreen();
      } else if (elem.msExitFullscreen) {
        elem.msExitFullscreen();
      }
    }
  } catch (e) {
    console.warn(e);
  }
  
}